module.exports = __webpack_public_path__ + "static/media/cozy_cafe.c7c77c37.png";